import { first } from 'rxjs/operators';

import type { Observable } from 'rxjs';

export const getValue = <T>(observable: Observable<T>): T => {
  let result: T;
  let hasValue = false;

  const subscription = observable.pipe(first()).subscribe((value: T) => {
    result = value;
    hasValue = true;
  });

  subscription.unsubscribe();

  if (!hasValue) {
    throw new Error(
      'GetValue RxJs helper - cannot read value from asynchronous Observable source',
    );
  }

  return result;
};
